module.exports = __webpack_public_path__ + "static/media/login-bg-17.1bf23cfc.jpg";